import { NgModule } from '@angular/core';
import { ToPlainTextPipe } from './to-plain-text.pipe';

@NgModule({
  declarations: [ToPlainTextPipe],
  exports: [ToPlainTextPipe],
})
export class ToPlainTextPipeModule {}
